import { type FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card } from '../components/ui/card';
import { AuthStatusIcon } from '../components/auth/AuthStatusIcon';
import { forgotPassword } from '../lib/api';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    await forgotPassword(email); // always resolves — never reveals whether the email exists
    setBusy(false);
    setSent(true);
  }

  if (sent) {
    return (
      <Card className="flex flex-col items-center gap-4 p-8 text-center">
        <AuthStatusIcon variant="success" />
        <div>
          <h1 className="font-display text-xl font-bold text-bone">Check your inbox</h1>
          <p className="mt-1 text-sm text-muted">
            If an account exists for <span className="text-bone">{email}</span>, we've sent a link
            to reset your password.
          </p>
        </div>
        <Link to="/login" className="text-sm text-iris hover:text-iris-strong">
          Back to sign in
        </Link>
      </Card>
    );
  }

  return (
    <Card className="space-y-5 p-8">
      <div>
        <h1 className="font-display text-xl font-bold text-bone">Reset your password</h1>
        <p className="mt-1 text-sm text-muted">
          Enter your email and we'll send you a link to set a new one.
        </p>
      </div>
      <form onSubmit={onSubmit} className="space-y-3">
        <Input
          type="email"
          required
          placeholder="Work email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Button type="submit" disabled={busy || !email} className="w-full">
          {busy ? 'Sending…' : 'Send reset link'}
        </Button>
      </form>
      <p className="text-sm">
        <Link to="/login" className="text-iris hover:text-iris-strong">
          Back to sign in
        </Link>
      </p>
    </Card>
  );
}
